module.exports = __webpack_public_path__ + "96e14b3447602482a291a0e5f64caf4b.svg";